module.exports = __webpack_public_path__ + "img/04467af.jpg";